import { render, staticRenderFns } from "./NavDesktop.vue?vue&type=template&id=6d2a9f22&scoped=true"
import script from "./NavDesktop.vue?vue&type=script&lang=js"
export * from "./NavDesktop.vue?vue&type=script&lang=js"
import style0 from "./NavDesktop.vue?vue&type=style&index=0&id=6d2a9f22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2a9f22",
  null
  
)

export default component.exports